<template>
  <div class="adv-container">
    <!-- 头部 -->
    <div class="adv-header">
      <div class="adv-header-left">
        <h1 class="adv-title">
          <i class="fas fa-bullhorn"></i>
          {{ $t('_ggtf._bt1') }}
        </h1>
        <span class="title-badge">{{ $t('_ggtf._hot') }}</span>
      </div>
      <div class="adv-tabs">
        <button
          :class="['adv-tab', { active: activeTab === 'list' }]"
          @click="switchTab('list')"
        >
          <i class="fas fa-list"></i>
          {{ $t('_ggtf._splb') }}
        </button>
        <button
          :class="['adv-tab', { active: activeTab === 'my' }]"
          @click="switchTab('my')"
        >
          <i class="fas fa-user-check"></i>
          {{ $t('_ggtf._wcyd') }}
        </button>
      </div>
    </div>

    <!-- 内容区 -->
    <div class="adv-content">
      <VideoAdvList v-if="activeTab === 'list'" />
      <VideoMyAdvList v-else />
    </div>
  </div>
</template>

<script>
import VideoAdvList from '@/components/adv/VideoAdvList.vue'
import VideoMyAdvList from '@/components/adv/VideoMyAdvList.vue'

export default {
  name: 'AdDelivery',
  components: {
    VideoAdvList,
    VideoMyAdvList
  },
  data() {
    return {
      activeTab: 'list'
    }
  },
  created() {
    const tab = this.$route.query.active
    if (tab === 'list' || tab === 'my') {
      this.activeTab = tab
    }
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab
      this.$router.replace({ query: { ...this.$route.query, active: tab } })
    }
  }
}
</script>

<style scoped>
/* ============================================================
   广告投放 - 暗色主题
   ============================================================ */

.adv-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 24px 40px;
  background: #0b0d0f;
  min-height: 100vh;
  color: #e8edf2;
}

/* ============================================================
   头部
   ============================================================ */
.adv-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #0f1419;
  border-radius: 14px;
  border: 1px solid #1a1f26;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;
}

.adv-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.adv-title {
  font-size: 22px;
  font-weight: 700;
  color: #e8edf2;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.adv-title i {
  color: #e50914;
}

.title-badge {
  background: linear-gradient(135deg, #e50914, #b20710);
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  padding: 3px 12px;
  border-radius: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

/* ============================================================
   Tab 切换
   ============================================================ */
.adv-tabs {
  display: flex;
  gap: 4px;
  background: #0a0d0f;
  padding: 4px;
  border-radius: 10px;
  border: 1px solid #1a1f26;
}

.adv-tab {
  padding: 8px 20px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #5a6672;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.adv-tab:hover {
  color: #8a949f;
  background: rgba(255, 255, 255, 0.03);
}

.adv-tab.active {
  color: #e8edf2;
  background: rgba(229, 9, 20, 0.12);
}

.adv-tab i {
  font-size: 14px;
}

/* ============================================================
   内容区
   ============================================================ */
.adv-content {
  background: #0f1419;
  border-radius: 14px;
  border: 1px solid #1a1f26;
  padding: 20px 24px;
  min-height: 400px;
}

/* ============================================================
   子组件样式穿透
   ============================================================ */
.adv-content :deep(.video-adv-list),
.adv-content :deep(.video-my-adv-list) {
  background: transparent;
  color: #e8edf2;
}

.adv-content :deep(.adv-card) {
  background: #0a0d0f;
  border: 1px solid #1a1f26;
  border-radius: 12px;
  transition: border-color 0.25s ease;
}

.adv-content :deep(.adv-card:hover) {
  border-color: #e50914;
}

.adv-content :deep(.adv-title-text) {
  color: #e8edf2;
}

.adv-content :deep(.adv-desc) {
  color: #8a949f;
}

.adv-content :deep(.adv-price) {
  color: #ffb300;
}

.adv-content :deep(.adv-btn) {
  background: linear-gradient(135deg, #e50914, #b20710);
  color: #fff;
  border: none;
  border-radius: 50px;
  padding: 8px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.adv-content :deep(.adv-btn:hover) {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(229, 9, 20, 0.3);
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 768px) {
  .adv-container {
    padding: 12px 12px 30px;
  }

  .adv-header {
    flex-direction: column;
    align-items: stretch;
    padding: 14px 16px;
    gap: 12px;
  }

  .adv-header-left {
    justify-content: center;
  }

  .adv-title {
    font-size: 18px;
  }

  .adv-tabs {
    justify-content: stretch;
  }

  .adv-tab {
    flex: 1;
    justify-content: center;
    padding: 8px 12px;
    font-size: 13px;
  }

  .adv-content {
    padding: 14px 16px;
    border-radius: 12px;
    min-height: 300px;
  }
}

@media (max-width: 480px) {
  .adv-title {
    font-size: 16px;
  }

  .adv-title i {
    font-size: 16px;
  }

  .title-badge {
    font-size: 9px;
    padding: 2px 10px;
  }

  .adv-tab {
    font-size: 12px;
    padding: 6px 10px;
  }

  .adv-tab i {
    font-size: 12px;
  }

  .adv-content {
    padding: 10px 12px;
    min-height: 250px;
  }
}
</style>